/*
 * Halong Abholzeit: Abholtag und Abholzeit im Warenkorb (ersetzt Bird Pickup Delivery).
 * Zwei große Auswahlfelder: erst Tag, dann Uhrzeit (Wunsch Karim 08.10.: weniger Knöpfe auf einmal).
 * Schreibt feste Warenkorb-Attribute, die print.php per Name liest. Zeitzone immer Europe/Berlin.
 * Die Telefonnummer ist Pflicht im Shopify-Checkout (Lieferadresse), nicht hier.
 */
(() => {
  if (window.customElements.get('halong-abholzeit')) return;

  const TZ = 'Europe/Berlin';
  const WEEKDAYS_DE = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  const WEEKDAYS_EN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const pad = (n) => String(n).padStart(2, '0');
  const root = () => window.Shopify?.routes?.root || '/';

  /** Aktuelles Datum/Uhrzeit in Berlin, unabhängig von der Zeitzone des Geräts. */
  function berlinNow() {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).map((p) => [p.type, p.value])
    );
    return { y: +parts.year, m: +parts.month, d: +parts.day, minutes: +parts.hour * 60 + +parts.minute };
  }

  /** "11:00-15:00, 17:00-22:00" -> [[660, 900], [1020, 1320]]; leer/"geschlossen" -> [] */
  function parseHours(text) {
    if (!text || /geschlossen|closed/i.test(text)) return [];
    return text.split(/[,;]/).map((range) => {
      const m = range.trim().match(/^(\d{1,2})[:.](\d{2})\s*-\s*(\d{1,2})[:.](\d{2})$/);
      return m ? [+m[1] * 60 + +m[2], +m[3] * 60 + +m[4]] : null;
    }).filter((r) => r && r[1] > r[0]);
  }

  /** Wie viele Tage ein "von - bis"-Eintrag höchstens sperrt (Tippfehler im Jahr sollen nicht ein Jahrzehnt schließen). */
  const MAX_RANGE_DAYS = 366;

  /** Datum aus Tag/Monat/Jahr (Jahr auch zweistellig) als UTC-Zeitstempel; null bei unmöglichem Datum (z. B. 31.02.). */
  function utcDay(d, m, y) {
    const year = y.length === 2 ? 2000 + +y : +y;
    const ts = Date.UTC(year, +m - 1, +d);
    const back = new Date(ts);
    return back.getUTCFullYear() === year && back.getUTCMonth() === +m - 1 && back.getUTCDate() === +d ? ts : null;
  }

  /**
   * Geschlossene Tage aus dem Theme-Editor: "24.12.2026", "13.10.26" und Zeiträume "01.08.2026 - 15.08.2026" / "... bis ...".
   * Getrennt durch Zeilen, Komma oder Leerzeichen; alles andere wird überlesen. Liefert ein Set aus ISO-Daten.
   */
  function parseClosedDates(text) {
    const closed = new Set();
    const re = /(\d{1,2})\.(\d{1,2})\.(\d{4}|\d{2})(?!\d)(?:\s*(?:-|–|—|bis)\s*(\d{1,2})\.(\d{1,2})\.(\d{4}|\d{2})(?!\d))?/gi;
    for (const m of String(text || '').matchAll(re)) {
      const from = utcDay(m[1], m[2], m[3]);
      const to = m[4] ? utcDay(m[4], m[5], m[6]) : from;
      if (from === null || to === null || to < from || (to - from) / 86400000 >= MAX_RANGE_DAYS) continue;
      for (let ts = from; ts <= to; ts += 86400000) {
        const d = new Date(ts);
        closed.add(`${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`);
      }
    }
    return closed;
  }

  /** Pause: Express-Zahlarten (PayPal, Apple Pay, Google Pay) umgehen den Kassen-Knopf, deshalb blenden wir sie aus. */
  function hideExpressCheckout() {
    if (document.getElementById('ha-pause-style')) return;
    const st = document.createElement('style');
    st.id = 'ha-pause-style';
    st.textContent = '.additional-checkout-buttons, shopify-accelerated-checkout-cart, shopify-accelerated-checkout { display: none !important; }';
    document.head.appendChild(st);
  }

  const toTime = (t) => `${pad(Math.floor(t / 60))}:${pad(t % 60)}`;

  /* Restaurant Halong 2026-10-09 (R-010): Gerichte der Kollektion „mittagsmenu“ gibt es nur zum Mittagspreis
     Dienstag bis Samstag 11 bis 15 Uhr (wie custom-script.js, isLunchTime). Liegt eins im Warenkorb, bietet die
     Abholzeit nur Zeiten in diesem Fenster an; die Kasse prüft es vor dem Checkout noch einmal gegen /cart.js. */
  const LUNCH_DAYS = [2, 3, 4, 5, 6];
  const LUNCH_FROM = 11 * 60;
  const LUNCH_TO = 15 * 60;
  const LUNCH_TEXT = 'Mit Mittagsgericht ist die Abholung nur Dienstag bis Samstag zwischen 11 und 15 Uhr möglich.';
  const hasLunch = (cfg) => (cfg.cartProductIds || []).some((id) => (cfg.lunchIds || []).includes(Number(id)));

  /** Buchbare Abholtage ab heute (Berlin); Slots je Öffnungsblock als "Mittag"/"Abend". */
  function buildDays(cfg) {
    if (cfg.paused) return [];
    const now = berlinNow();
    const closed = parseClosedDates(cfg.closedDates);
    const days = [];
    for (let i = 0; i <= cfg.daysAhead; i += 1) {
      const date = new Date(Date.UTC(now.y, now.m - 1, now.d + i));
      const iso = `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
      if (closed.has(iso)) continue;
      const weekday = date.getUTCDay();
      const lunchOnly = hasLunch(cfg);
      if (lunchOnly && !LUNCH_DAYS.includes(weekday)) continue;
      const earliest = i === 0 ? now.minutes + cfg.leadMinutes : -1;
      const periods = [];
      for (const [open, close] of parseHours(cfg.hours[weekday])) {
        const slots = [];
        for (let t = open + cfg.firstOffset; t <= close - cfg.lastOffset; t += cfg.slotMinutes) {
          if (t >= earliest && (!lunchOnly || (t >= LUNCH_FROM && t <= LUNCH_TO))) slots.push(toTime(t));
        }
        if (slots.length) periods.push({ name: open < 16 * 60 ? 'Mittag' : 'Abend', slots });
      }
      if (periods.length) days.push({ iso, date, weekday, index: i, periods, slots: periods.flatMap((p) => p.slots) });
    }
    return days;
  }

  const shortDate = (d) => `${pad(d.date.getUTCDate())}.${pad(d.date.getUTCMonth() + 1)}.`;
  const relative = (d) => (d.index === 0 ? 'Heute' : d.index === 1 ? 'Morgen' : WEEKDAYS_DE[d.weekday]);

  /** Feste Attribut-Namen: Deutsch für Bon/Admin, Bird-Format nur zur Kompatibilität mit Order Printer. */
  function buildAttributes(day, time) {
    const d = day.date;
    const [hh, mm] = time.split(':').map(Number);
    const de = `${pad(d.getUTCDate())}.${pad(d.getUTCMonth() + 1)}.${d.getUTCFullYear()}`;
    const h12 = hh % 12 === 0 ? 12 : hh % 12;
    return {
      Abholung: `${WEEKDAYS_DE[day.weekday]}, ${de}, ${time} Uhr`,
      Abholdatum: de,
      Abholzeit: time,
      'Delivery Method': 'Pick Up',
      'Delivery Date': `${MONTHS_EN[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}`,
      'Delivery Day': WEEKDAYS_EN[day.weekday],
      'Delivery Time': `${h12}:${pad(mm)} ${hh < 12 ? 'AM' : 'PM'}`,
      'Translated Delivery Time': time,
    };
  }

  async function postAttributes(attributes) {
    const res = await fetch(`${root()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    });
    if (!res.ok) throw new Error(`cart/update ${res.status}`);
    return res.json();
  }

  /** <option> mit Text und Wert. */
  function opt(label, value, selected) {
    const o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    o.selected = selected;
    return o;
  }

  const dayLabel = (d) => `${relative(d)}, ${shortDate(d)}`; // kurz, damit es auch im schmalen Warenkorb-Drawer passt

  class HalongAbholzeit extends HTMLElement {
    connectedCallback() {
      this.cfg = JSON.parse(this.dataset.config || '{}');
      const saved = JSON.parse(this.dataset.saved || '{}');
      this.dayEl = this.querySelector('[data-ha-day]');
      this.timeEl = this.querySelector('[data-ha-time]');
      this.hintEl = this.querySelector('[data-ha-hint]');
      this.earliestEl = this.querySelector('[data-ha-earliest]');
      this.errorEl = this.querySelector('[data-ha-error]');
      this.lunchEl = document.createElement('p');
      this.lunchEl.className = 'ha__hint';
      this.lunchEl.textContent = LUNCH_TEXT;
      this.errorEl.before(this.lunchEl);

      if (this.cfg.paused) hideExpressCheckout();
      this.days = buildDays(this.cfg);
      const savedIso = (saved.Abholdatum || '').replace(/^(\d{2})\.(\d{2})\.(\d{4})$/, '$3-$2-$1');
      const savedDay = this.days.find((d) => d.iso === savedIso);
      // Restaurant Halong 2026-10-08 (UI-Prüfung H6): ohne gespeicherte Wahl ist „Heute“ vorgewählt, wenn heute noch
      // Abholzeiten frei sind. Die Uhrzeit bleibt eine bewusste Wahl (Pflicht für den Küchenbon), gespeichert wird erst mit ihr.
      const todayDay = this.days.find((d) => d.index === 0);
      this.state = {
        iso: savedDay ? savedDay.iso : (todayDay ? todayDay.iso : ''),
        time: savedDay && savedDay.slots.includes(saved.Abholzeit) ? saved.Abholzeit : '',
      };

      this.dayEl.addEventListener('change', () => {
        this.state = { iso: this.dayEl.value, time: '' };
        this.showError('');
        this.update();
        if (this.state.iso) this.timeEl.focus();
      });
      this.timeEl.addEventListener('change', () => {
        this.state = { ...this.state, time: this.timeEl.value };
        this.showError('');
        this.persist();
      });

      if (!this.days.length) this.showError(this.unavailableMessage());
      this.update();
    }

    /** Pause (Theme-Editor) zeigt den Text des Betreibers; sonst Mittags- oder Standardtext. */
    unavailableMessage() {
      if (this.cfg.paused) return this.cfg.pausedMessage || 'Online-Bestellungen sind gerade nicht möglich. Bitte ruf uns an.';
      return hasLunch(this.cfg) ? `${LUNCH_TEXT} Gerade ist keine Mittagszeit frei. Bitte entferne das Mittagsgericht oder ruf uns an.` : 'Online-Bestellungen sind gerade nicht möglich. Bitte ruf uns an.';
    }

    get day() { return this.days.find((d) => d.iso === this.state.iso); }

    update() {
      const day = this.day;
      this.lunchEl.hidden = !hasLunch(this.cfg);
      this.dayEl.replaceChildren(opt('Tag wählen', '', !day), ...this.days.map((d) => opt(dayLabel(d), d.iso, d.iso === this.state.iso)));

      const today = this.days.find((d) => d.index === 0);
      this.hintEl.hidden = !today;
      if (today) this.earliestEl.textContent = `${today.slots[0]} Uhr`;

      this.timeEl.disabled = !day;
      if (!day) { this.timeEl.replaceChildren(opt('Erst Tag wählen', '', true)); return; }
      const groups = day.periods.map((p) => {
        const g = document.createElement('optgroup');
        g.label = p.name;
        g.append(...p.slots.map((s) => opt(`${s} Uhr`, s, s === this.state.time)));
        return g;
      });
      this.timeEl.replaceChildren(opt('Uhrzeit wählen', '', !this.state.time), ...groups);
    }

    showError(message) {
      this.errorEl.textContent = message;
      this.errorEl.hidden = !message;
      this.classList.toggle('ha--error', Boolean(message));
    }

    /** Zwischenspeichern, damit die Auswahl ein Neuladen des Drawers übersteht; Fehler hier sind unkritisch. */
    persist() {
      const day = this.day;
      if (!day || !this.state.time) return;
      postAttributes(buildAttributes(day, this.state.time))
        .catch((err) => console.warn('[halong-abholzeit] Zwischenspeichern fehlgeschlagen', err));
    }

    /** Prüft die Auswahl gegen die aktuelle Uhrzeit; liefert Attribute oder null (mit Fehlermeldung). */
    collect() {
      this.days = buildDays(this.cfg);
      if (this.cfg.paused) {
        this.update();
        this.showError(this.unavailableMessage());
        return null;
      }
      const day = this.day;
      if (hasLunch(this.cfg) && this.state.time && (!day || !day.slots.includes(this.state.time))) {
        this.state = { iso: day ? day.iso : '', time: '' };
        this.update();
        this.showError(this.days.length ? `${LUNCH_TEXT} Bitte wähle eine Mittagszeit.` : `${LUNCH_TEXT} Gerade ist keine Mittagszeit frei. Bitte entferne das Mittagsgericht oder ruf uns an.`);
        this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        return null;
      }
      if (!day || !this.state.time) {
        this.update();
        this.showError(day ? 'Bitte wähle eine Uhrzeit.' : 'Bitte wähle zuerst den Tag, dann die Uhrzeit.');
        this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        return null;
      }
      if (!day.slots.includes(this.state.time)) {
        this.state = { ...this.state, time: '' };
        this.update();
        this.showError('Diese Uhrzeit ist schon vorbei. Bitte wähle eine neue.');
        return null;
      }
      this.showError('');
      return buildAttributes(day, this.state.time);
    }

    /** Vor dem Checkout: validieren, speichern und das Ergebnis im Warenkorb nachlesen (Wirkung statt Quittung). */
    async commit() {
      // R-010: Warenkorb frisch lesen, der Drawer kann seit dem Rendern ein Mittagsgericht dazubekommen haben.
      try {
        const res = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } });
        if (res.ok) this.cfg.cartProductIds = ((await res.json()).items || []).map((i) => i.product_id);
      } catch (err) {
        console.warn('[halong-abholzeit] Warenkorb nicht gelesen, Prüfung mit dem Stand beim Laden', err);
      }
      const attrs = this.collect();
      if (!attrs) return false;
      try {
        const cart = await postAttributes(attrs);
        const stored = cart.attributes || {};
        if (stored.Abholdatum !== attrs.Abholdatum || stored.Abholzeit !== attrs.Abholzeit) {
          throw new Error('Attribute nach dem Speichern nicht im Warenkorb');
        }
        return true;
      } catch (err) {
        console.error('[halong-abholzeit]', err);
        this.showError('Deine Abholzeit konnte nicht gespeichert werden. Bitte versuch es noch einmal.');
        return false;
      }
    }
  }

  window.customElements.define('halong-abholzeit', HalongAbholzeit);
  window.__halongAbholzeit = { buildDays, buildAttributes, parseHours, parseClosedDates, hasLunch };

  /* Jeder Weg zur Kasse läuft über commit(): Drawer-Button, Cart-Seite, Links auf /checkout. */
  let busy = false;
  async function guard(event) {
    const target = event.target;
    // Drawer-Button gehört zur Auswahl im Drawer, alles andere zur Auswahl auf der Cart-Seite.
    const scope = target.closest?.('cart-drawer') || document.querySelector('main') || document;
    const el = scope.querySelector('halong-abholzeit') || document.querySelector('halong-abholzeit');
    if (!el || !el.isConnected || typeof el.commit !== 'function') return;
    const isCheckout = event.type === 'submit'
      ? Boolean(event.submitter?.name === 'checkout' || target.querySelector?.('[name="checkout"]'))
      : Boolean(target.closest?.('button[name="checkout"], a[href*="/checkout"]'));
    if (!isCheckout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    const button = target.closest?.('button') || event.submitter;
    button?.setAttribute('aria-busy', 'true');
    try {
      // Beilagen müssen zu ihrem Gericht passen (halong-beilage.js); wurde korrigiert, sieht der Kunde erst den Warenkorb.
      const beilageOk = window.__halongBeilage ? await window.__halongBeilage.ensure() : true;
      if (await el.commit() && beilageOk) window.location.href = `${root()}checkout`;
    } finally {
      busy = false;
      button?.removeAttribute('aria-busy');
    }
  }
  // window statt document: die Capture-Phase von window läuft vor allen document-Listenern.
  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);
})();
